/* iremotos.eu — premium interactions (vanilla, no deps) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---- Sticky header state + scroll progress ---- */
  var header = document.querySelector('.header');
  var progress = document.querySelector('.scroll-progress');
  function onScroll() {
    var y = window.scrollY || 0;
    if (header) header.classList.toggle('is-stuck', y > 10);
    if (progress) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (h > 0 ? (y / h) * 100 : 0) + '%';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Scroll reveals ---- */
  var revealEls = document.querySelectorAll('[data-reveal], .stagger');
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Hero headline word stagger ---- */
  var heroH1 = document.querySelector('.hero h1[data-split]');
  if (heroH1 && !reduced) {
    var words = heroH1.textContent.trim().split(/\s+/);
    heroH1.innerHTML = words.map(function (w, i) {
      return '<span class="word" style="opacity:0;transform:translateY(40px);display:inline-block;transition:opacity .7s cubic-bezier(.2,.7,.2,1) ' + (i * 0.07) + 's, transform .7s cubic-bezier(.2,.7,.2,1) ' + (i * 0.07) + 's">' + w + '</span>';
    }).join(' ');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        heroH1.querySelectorAll('.word').forEach(function (s) { s.style.opacity = '1'; s.style.transform = 'none'; });
      });
    });
  }

  /* ---- Magnetic buttons (desktop) ---- */
  if (!reduced && window.matchMedia('(pointer:fine)').matches) {
    document.querySelectorAll('.btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width / 2;
        var my = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + mx * 0.18 + 'px,' + (my * 0.18 - 2) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---- Tilt on cards / tiles (desktop) ---- */
  if (!reduced && window.matchMedia('(pointer:fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -6;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 6;
        el.style.transform = 'perspective(800px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(-8px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- Animated stat counters ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1400, start = performance.now();
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reduced ? (en.target.textContent = en.target.getAttribute('data-count') + (en.target.getAttribute('data-suffix') || '')) : animateCount(en.target); cio.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---- Product gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-img]');
    if (main) { main.style.opacity = '0'; setTimeout(function () { main.src = thumb.getAttribute('data-full'); main.style.opacity = '1'; }, 150); }
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
    var form = input.closest('form');
    if (form) form.submit();
  });

  /* ---- Currency / localization selector ---- */
  /* inline <select> (footer/mobile): submit on change */
  document.querySelectorAll('form.localization select[name="country_code"]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });
  /* compact header dropdown: close when clicking outside */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-currency-menu][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---- Product variant picker ---- */
  (function () {
    var form = document.getElementById('product-form');
    var dataEl = document.querySelector('[data-variant-json]');
    if (!form || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('select[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var btn = form.querySelector('[data-add-btn]');
    var btnText = form.querySelector('[data-add-text]');
    var currency = dataEl.getAttribute('data-currency') || 'EUR';
    var addLabel = btn ? btn.getAttribute('data-label-add') : 'Add to cart';
    var soldLabel = btn ? btn.getAttribute('data-label-soldout') : 'Sold out';

    function money(cents) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return '€' + (cents / 100).toFixed(2); }
    }
    function chosen() { return Array.prototype.map.call(selects, function (s) { return s.value; }); }
    function update() {
      if (!selects.length) return;
      var sel = chosen();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      })[0];
      if (!match) { // unavailable combo
        if (btn) { btn.disabled = true; btn.type = 'button'; }
        if (btnText) btnText.textContent = soldLabel;
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceNow) {
        priceNow.textContent = money(match.price);
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        priceNow.classList.toggle('price--sale', !!onSale);
        if (priceWas) {
          if (onSale) { priceWas.textContent = money(match.compare_at_price); priceWas.style.display = ''; }
          else { priceWas.style.display = 'none'; }
        }
      }
      if (btn) {
        if (match.available) { btn.disabled = false; btn.type = 'submit'; if (btnText) btnText.textContent = addLabel + ' — ' + money(match.price); }
        else { btn.disabled = true; btn.type = 'button'; if (btnText) btnText.textContent = soldLabel; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  })();

  /* ---- Live cart count ---- */
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
})();
